import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { useCallback } from 'react';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import JobRoleTypeahead from 'signup-ui-job-role/components/JobRoleTypeahead';
import { useJobRole } from '../job-role/useJobRole';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { ErrorMessage } from '../views-components/ErrorMessage';
import { InputStyles } from '../views-components/TextInput.styles';
import { TypeaheadFormControl } from '../views/Forms.styles';
export const JobRoleSelect = () => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    isEmbedded
  } = useSignupEmbedder();
  const {
    jobRoleSelectedValue,
    jobRoleInputValue,
    setTrackedUserInput,
    setSelectedValue
  } = useJobRole();
  const doesInputMatchSelection = jobRoleSelectedValue === jobRoleInputValue;
  const hasInputValue = Boolean(jobRoleInputValue);
  const isInvalid = hasInputValue && !doesInputMatchSelection;
  const renderErrorMessage = useCallback(() => {
    return isInvalid ? /*#__PURE__*/_jsx(ErrorMessage, {
      dataKey: Data.JobRole
    }) : null;
  }, [isInvalid]);
  return /*#__PURE__*/_jsx(TypeaheadFormControl, {
    error: isInvalid,
    label: I18n.text(`data.${Data.JobRole}.default.label`),
    validationMessage: renderErrorMessage(),
    children: /*#__PURE__*/_jsx(InputStyles, {
      error: isInvalid,
      industryStyle: true,
      success: Boolean(jobRoleSelectedValue),
      children: /*#__PURE__*/_jsx(JobRoleTypeahead, {
        focusTimeout: 500,
        inputValue: jobRoleInputValue,
        isMobile: isMobile && !isEmbedded,
        shouldShowPlaceholder: false,
        shouldUseRelevantSearch: true,
        onInputValueChange: setTrackedUserInput,
        onSelectOptionChange: setSelectedValue
      })
    })
  });
};